import type { DigestWriter } from '@/api/types'

/**
 * Who wrote a digest, in the reader's words (ADR-0009 D9.7). Only a model's
 * text is called AI; the template's — including when it stands in for the
 * model — is a summary.
 */
export function writerLabel(writer: DigestWriter): string {
  return writer === 'claude' ? 'Written by AI from your figures' : 'Summary of your figures'
}

export function isAiWritten(writer: DigestWriter | null): boolean {
  return writer === 'claude'
}
